import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const supplierService = {
	getAllSuppliers,
	getSupplier,
	createSupplier,
	updateSupplier,
	updateSupplierStatus,
};

const API_URL = API.BASE_URL;

export function getAllSuppliers(filter) {
	const requestOptions = {
		params: {
			page: filter?.pageNumber,
			size: filter?.pageSize,
			is_active: filter?.isActive,
		},
	};
	let array = filter?.searchArray;
	array?.forEach((word, index) => {
		if (word != null && word != '') {
			requestOptions.params[`search_words[${index}]`] = word;
		}
	});
	return apiHelper(API_URL).get('/v1/suppliers', requestOptions);
}

export function getSupplier(id) {
	return apiHelper(API_URL).get(`/v1/suppliers/${id}`);
}

export function createSupplier(data) {
	const requestOptions = {
		name: data.name,
		code: data.code,
		email: data.email,
		phone: data.phone,
	};
	return apiHelper(API_URL).post('/v1/suppliers', requestOptions);
}

export function updateSupplier(data) {
	const requestOptions = {
		name: data.name,
		code: data.code,
		email: data.email,
		phone: data.phone,
	};
	return apiHelper(API_URL).put(`/v1/suppliers/${data.id}`, requestOptions);
}

export function updateSupplierStatus(data) {
	return apiHelper(API_URL).patch(`/v1/suppliers/${data.uuid}/status`, {
		is_active: data.isActive,
	});
}
